import React, { useState } from 'react'
import styled from '@emotion/styled'
import { DecodedItem } from 'stylewhere/api'
import { Box, DecodedItemsModal, SmallTextCounter } from 'stylewhere/components'
import { T, __ } from 'stylewhere/i18n'
import { OperationConfig } from 'stylewhere/shared'

type Props = {
  items: DecodedItem[]
  operation?: OperationConfig
}

export const OperationReadingCounters: React.FC<Props> = ({ items, operation }) => {
  const [modalVisible, setModalVisible] = useState<false | 'error' | 'warning' | 'ignored'>(false)
  const errorItems = items.filter((itm) => itm.item?.status === 'error')
  const warningItems = items.filter((itm) => itm.item?.status === 'warning')
  const ignoredItems = items.filter((itm) => itm.item?.status === 'ignored')

  let modalTitle = ''
  if (modalVisible === 'error') {
    modalTitle = __(T.fields.error_items)
  }
  if (modalVisible === 'warning') modalTitle = __(T.fields.warning_items)
  if (modalVisible === 'ignored') modalTitle = __(T.fields.ignored_items)

  return (
    <Container row justify="space-evenly">
      {errorItems.length > 0 && (
        <SmallTextCounter
          counter={errorItems.length}
          title={__(T.error.error)}
          status="error"
          onClick={() => setModalVisible('error')}
        />
      )}
      {warningItems.length > 0 && (
        <SmallTextCounter
          counter={warningItems.length}
          title={__(T.misc.warning)}
          status="warning"
          onClick={() => setModalVisible('warning')}
        />
      )}
      {ignoredItems.length > 0 && (
        <SmallTextCounter
          counter={ignoredItems.length}
          title={__(T.misc.ignored)}
          status="ignored"
          onClick={() => setModalVisible('ignored')}
        />
      )}

      {modalVisible === 'error' && (
        <DecodedItemsModal
          decodedItems={errorItems}
          operation={operation}
          isOpen
          onClose={() => setModalVisible(false)}
          title={modalTitle}
        />
      )}
      {modalVisible === 'warning' && (
        <DecodedItemsModal
          decodedItems={warningItems}
          operation={operation}
          isOpen
          onClose={() => setModalVisible(false)}
          title={modalTitle}
        />
      )}
      {modalVisible === 'ignored' && (
        <DecodedItemsModal
          decodedItems={ignoredItems}
          operation={operation}
          isOpen
          onClose={() => setModalVisible(false)}
          title={modalTitle}
        />
      )}
    </Container>
  )
}

const Container = styled(Box)`
  > * + * {
    margin-left: 10px;
  }
`
